import { forwardRef } from "react";
import { IMaskInput } from "react-imask";

function toMaskValue(value) {
    if (value == null) return "";
    return String(value);
}

export const TextMaskCNPJ = forwardRef(function TextMaskCNPJ(props, ref) {
    const { value, ...rest } = props;
    return (
        <IMaskInput
            {...rest}
            value={toMaskValue(value)}
            mask="00.000.000/0000-00"
            definitions={{
                "#": /[0-9]/,
            }}
            inputRef={ref}
            overwrite
        />
    );
});

export const TextMaskPhone = forwardRef(function TextMaskPhone(props, ref) {
    const { value, ...rest } = props;
    return (
        <IMaskInput
            {...rest}
            value={toMaskValue(value)}
            mask="(00) 00000-0000"
            definitions={{
                "#": /[0-9]/,
            }}
            inputRef={ref}
            overwrite
        />
    );
});

export const TextMaskCEP = forwardRef(function TextMaskCEP(props, ref) {
    const { value, ...rest } = props;
    return (
        <IMaskInput
            {...rest}
            value={toMaskValue(value)}
            mask="00000-000"
            definitions={{
                "#": /[0-9]/,
            }}
            inputRef={ref}
            overwrite
        />
    );
});